export default "__VITE_ASSET__SK9fehLM__"